import { useMemo } from 'react'

/**
 * Stable 1-based index by sensor_id sort order for demo-mode display labels only.
 * @param {Array<{ sensor_id: string }>} sensors
 */
export function useDemoWaterLabelBySensorId(sensors) {
	return useMemo(() => {
		const sorted = [...sensors].sort((a, b) =>
			String(a.sensor_id).localeCompare(String(b.sensor_id), undefined, { sensitivity: 'base' })
		)
		const map = new Map()
		sorted.forEach((s, i) => map.set(s.sensor_id, i + 1))
		return map
	}, [sensors])
}

export function demoWaterLabelFromMap(indexBySensorId, sensorId) {
	const n = indexBySensorId.get(sensorId)
	return n != null ? `Demo Water ${n}` : 'Demo Water'
}
